<mat-card appearance="outlined" class="user-summary-page">
  <mat-card-title>Permissions</mat-card-title>
  <mat-card-actions align="end">
    <button mat-icon-button color="primary" class="caaks-toolbar-action" matTooltip="Ajouter une permission"
      (click)="handleAddPermissionDialog()">
      <mat-icon class="caaks-primary-toolbar-icon">add</mat-icon>
    </button>
  </mat-card-actions>
  <mat-card-content>
    <div class="resume_" fxLayout="row wrap" fxCols="2" fxLayoutAlign="start start" fxLayoutGap="5% grid">
      @if (!loading) {
        <div class="datatable">
          <mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear
            matSortDirection="asc">
            @for (header of displayedColumns.slice(0, -1); track header) {
              <ng-container matColumnDef="{{header}}">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                disableClear="true">{{displayedColumnsName[displayedColumns.indexOf(header)]}}</mat-header-cell>
                <mat-cell *matCellDef="let resource" class="col-stretch-xl">
                  {{ resource[header]}}
                </mat-cell>
              </ng-container>
            }
            <ng-container matColumnDef="details">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let resource">
                <a (click)="handleEditPermissionDialog(resource)"><i class="material-icons">edit</i></a>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row class="caaks-detail-row"
            *matRowDef="let row; columns: displayedColumns; let index = index"></mat-row>
          </mat-table>
          @if (dataSource && dataSource.length === 0) {
            <p>Aucune données.</p>
          }
        </div>
      } @else {
                <div style="display: flex;
                padding: 0px 5% 5% 0px;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;"><mat-spinner [diameter]="40"></mat-spinner> <span
          style="margin-left: 10px;">Chargement des
        données...</span></div>
      }

      <router-outlet></router-outlet>
    </div>


  </mat-card-content>
</mat-card>